/*会务服务 */
import { $http, buildHeaders } from "./index";

//获取会议列表
export const meeting_service_page = (params) => {
  return $http.get("/admin/MeetingService/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//#region 签到管理

//获取会议签到日程列表
export const meeting_service_signin_page = (params) => {
  return $http.get("/admin/MeetingSchedule/signinList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取会议签到日程参会人列表
export const meeting_service_signin_attendee_page = (params) => {
  return $http.get("/admin/MeetingAttendeeSchedule/signinList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//标记签到
export const meeting_service_signin_dealSignin = (data) => {
  return $http.post("/admin/MeetingAttendeeSchedule/dealSignin", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 接送管理

//#region 接送机安排

//获取会议接送机安排列表
export const meeting_service_transport_pickup_page = (params) => {
  return $http.get("/admin/MeetingTransportPickup/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_service_transport_pickup_detail = (id) => {
  return $http.get(
    "/admin/MeetingTransportPickup/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//导出会议接送机安排列表
export const meeting_service_transport_pickup_export = (params) => {
  return $http.get("/admin/MeetingTransportPickup/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//获取会议车辆接送任务列表
export const meeting_service_transport_pickup_getMeetingCarTaskList = (
  params,
) => {
  return $http.get("/admin/MeetingTransportPickup/getMeetingCarTaskList", {
    params,
  });
};

//派车
export const meeting_service_transport_pickup_arrange = (data) => {
  return $http.post("/admin/MeetingTransportPickup/arrange", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//取消派车
export const meeting_service_transport_pickup_cancelArrange = (data) => {
  return $http.post("/admin/MeetingTransportPickup/cancelArrange", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 司机排班

//获取会议司机排班列表
export const meeting_service_pickup_car_page = (params) => {
  return $http.get("/admin/MeetingPickupCar/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_service_pickup_car_detail = (id) => {
  return $http.get(
    "/admin/MeetingPickupCar/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//导出会议司机排班列表
export const meeting_service_pickup_car_export = (params) => {
  return $http.get("/admin/MeetingPickupCar/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//获取参会人大交通票据列表
export const meeting_service_pickup_car_getAttendeeTicketList = (params) => {
  return $http.get("/admin/MeetingPickupCar/getAttendeeTicketList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加会议司机排班
export const meeting_service_pickup_car_arrange = (data) => {
  return $http.post("/admin/MeetingPickupCar/arrange", data, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//取消会议司机排班
export const meeting_service_pickup_car_cancel = (data) => {
  return $http.post("/admin/MeetingPickupCar/cancel", data, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//#endregion

//#endregion

//#region 大交通管理

//获取列表
export const meeting_service_transport_attendee_page = (params) => {
  return $http.get("/admin/MeetingTransportAttendee/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_service_transport_attendee_detail = (id) => {
  return $http.get(
    "/admin/MeetingTransportAttendee/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取详情
export const meeting_service_transport_attendee_search = (id) => {
  return $http.get(
    "/admin/MeetingTransportAttendee/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//导出大交通列表
export const meeting_service_transport_attendee_export = (params) => {
  return $http.get("/admin/MeetingTransportAttendee/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//导入嘉宾
export const meeting_service_transport_attendee_import = (data) => {
  return $http.post("/admin/MeetingTransportAttendee/import", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//获取未导入的人员列表
export const meeting_service_transport_attendee_conferee_page = (params) => {
  return $http.get("/admin/MeetingTransportAttendee/meetingAttendeeList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//人员  全部导入仅针对嘉宾，普通参会人通过此方法添加
export const meeting_service_transport_attendee_add = (data) => {
  return $http.post("/admin/MeetingTransportAttendee/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//取消
export const meeting_service_transport_attendee_edit = (data) => {
  return $http.post("/admin/MeetingTransportAttendee/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_service_transport_attendee_del = (data) => {
  return $http.post("/admin/MeetingTransportAttendee/del", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 就餐管理

//获取会议就餐日程列表
export const meeting_service_repast_page = (params) => {
  return $http.get("/admin/MeetingSchedule/repastList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取会议就餐日程参会人列表
export const meeting_service_repast_attendee_page = (params) => {
  return $http.get("/admin/MeetingAttendeeSchedule/repastList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//标记核验
export const meeting_service_repast_dealVerify = (data) => {
  return $http.post("/admin/MeetingAttendeeSchedule/dealVerify", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};
//#endregion

//#region 分房管理

//获取会议住宿安排房间列表
export const meeting_service_hotel_arrange_room_page = (params) => {
  return $http.get("/admin/MeetingHotelArrangeRoom/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取会议参会人员列表
export const meeting_service_hotel_arrange_room_attendee_page = (params) => {
  console.log(params);
  
  return $http.get("/admin/MeetingHotelArrangeRoom/meetingAttendeeList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//分配房间
export const meeting_service_hotel_arrange_room_allocateAttendee = (data) => {
  return $http.post("/admin/MeetingHotelArrangeRoom/allocateAttendee", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//取消分配房间
export const meeting_service_hotel_arrange_room_allocateAttendeeCancel = (data) => {
  return $http.post("/admin/MeetingHotelArrangeRoom/allocateAttendeeCancel", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion
